import React from 'react';


const Quiz = ({name}) => {
    // console.log(quiz)
    
    return (
        <div>
            <h3>Quiz of {name}</h3>
        </div>
    );
};

export default Quiz;